import { lazy } from 'react';

export const PlayerRemoveWithdrawalLimitForm = lazy(
  () => import('./PlayerRemoveWithdrawalLimitForm'),
);
